/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetCloudAccountsQuery,
  CloudAccountsSortInput,
  CloudAccountsSearchInput,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: CloudAccountsSortInput;
  filter?: CloudAccountsSearchInput;
  skip?: boolean;
};

export function useGetCloudAccounts({
  page,
  limit,
  sort,
  filter,
  skip,
}: Props) {
  const {
    data: cloudAccountsData,
    loading,
    error,
    refetch,
  } = useGetCloudAccountsQuery({
    variables: { page: Number(page), limit: Number(limit), sort, filter },
    skip,
  });
  const data = cloudAccountsData?.cloudAccounts?.result ?? [];
  const count = cloudAccountsData?.cloudAccounts?.pageInfo?.count ?? 0;

  return { data, loading, error, count, refetch } as const;
}
